import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem, IncorporationDateFormValues } from '../../../types';
import { corporateClientsRiskApi } from '../services';

export interface CorporateClientsIncorporationDatesFormState {
  formValues?: IncorporationDateFormValues;
  item?: RiskScoreItem;
}

const initialState: CorporateClientsIncorporationDatesFormState = {};

export const corporateClientsIncorporationDateFormSlice = createSlice({
  name: 'corporateClientsIncorporationDateForm',
  initialState,
  reducers: {
    clearIncorporationDateFormState: (state) => {
      state.formValues = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      corporateClientsRiskApi.endpoints.getIncorporationDate.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
      },
    );
  },
});

export const { clearIncorporationDateFormState } =
  corporateClientsIncorporationDateFormSlice.actions;

export default corporateClientsIncorporationDateFormSlice.reducer;
